import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider, useApp } from './context/AppContext';
import Header from './components/Header';
import BottomNav from './components/BottomNav';
import FloatingCart from './components/FloatingCart';
import Cart from './pages/Cart';
import Auth from './pages/Auth';
import Register from './pages/Register';
import RegisterPincodeGate from './pages/RegisterPincodeGate';
import PincodeFoodTypeStatus from './pages/PincodeFoodTypeStatus';
import Password from './pages/Password';
import OtpVerify from './pages/OtpVerify';
import NewPassword from './pages/NewPassword';
import Home from './pages/Home';
import Order from './pages/Order';
import History from './pages/History';
import Profile from './pages/Profile';
import Confirmation from './pages/Confirmation';
import HelpPage from './pages/HelpPage';
import Settings from './pages/Settings';
import ContactAnnam from './pages/ContactAnnam';
import AddAdditionalAddress from './pages/AddAdditionalAddress';

function AppLayout({ children }) {
  const { isAuthenticated } = useApp();

  return (
    <div className="flex flex-col min-h-screen text-gray-800 app-peach-bg">
      {isAuthenticated && <Header />}
      <main className="container flex-grow w-full px-4 py-6 mx-auto sm:px-6 lg:px-8">
        {children}
      </main>
      <FloatingCart />
      <BottomNav />
    </div>
  );
}


function AppRoutes() {
  const { isAuthenticated } = useApp();
  return (
    <Routes>
      <Route path="/" element={isAuthenticated ? <Navigate to="/home" /> : <Auth />} />
      <Route path="/register" element={<RegisterPincodeGate />} />
      <Route path="/register/pincode/status" element={<PincodeFoodTypeStatus />} />
      <Route path="/register/form" element={<Register />} />
      <Route path="/password" element={<Password />} />
      <Route path="/otpverify" element={<OtpVerify />} />
      <Route path="/newpassword" element={<NewPassword />} />
      <Route path="/home" element={<Protected><Home /></Protected>} />
      <Route path="/order" element={<Protected><Order /></Protected>} />
      <Route path="/history" element={<Protected><History /></Protected>} />
      <Route path="/profile" element={<Protected><Profile /></Protected>} />
      <Route path="/settings" element={<Protected><Settings /></Protected>} />
      <Route path="/contact-annam" element={<Protected><ContactAnnam /></Protected>} />
      <Route path="/cart" element={<Protected><Cart /></Protected>} />
      <Route path="/add-additional-address" element={<Protected><AddAdditionalAddress /></Protected>} />
      <Route path="/confirmation" element={<Protected><Confirmation /></Protected>} />
      <Route path="/help" element={<HelpPage />} />
      <Route path="/help/:pageId" element={<HelpPage />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

function Protected({ children }) {
  const { isAuthenticated, loading } = useApp();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen text-gray-500 app-peach-bg">
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <AppProvider>
      <Router>
        <AppLayout>
          <AppRoutes />
        </AppLayout>
      </Router>
    </AppProvider>
  );
}
